/// See following article for details of how to limit access usign AuthGuard, and user claims
/// https://blogs.msdn.microsoft.com/premier_developer/2018/03/07/angular-how-to-implement-role-based-security/
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuardService  {

  constructor(protected router: Router, private auth: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // If user is not logged in then start Login process.
    if (this.auth.isUserLoggedIn() === false) {

      // Use not authenticated, so set the url to navigate to after user authenticates or use default as Dashboard
      if (state && state.url)
        this.auth.AfterLoginNavigateTo = state.url;
      else
        this.auth.AfterLoginNavigateTo = "dashboard";

      this.auth.startAuthentication(false);
      return false;
    }

    const allowed = this.hasRequiredPermission(route.data['auth']);
    console.log('canActivate : ' + state.url + ' needs permission [' + route.data['auth'] + ']. Allowed = ' + allowed);
    return allowed;
  }

  public hasRequiredPermission(privName: string): boolean {
    if (privName) {
      return this.auth.hasPriv(privName);
    }
    else {
      return false;
    }
  }
}
